import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,73 C1181.81647,73 1368.84706,216.661176 1438.08,415.211765 C1448.13176,414.534118 1458.07059,411.823529 1468.23529,411.823529 C1717.38353,411.823529 1920,614.44 1920,863.588235 C1920,1112.73647 1717.38353,1315.35294 1468.23529,1315.35294 L1468.23529,1315.35294 L1016.47059,1315.35294 L1016.47059,1630.79765 L1202.37176,1444.78353 L1282.33412,1524.63294 L960,1846.96706 L637.665882,1524.63294 L717.628235,1444.78353 L903.529412,1630.79765 L903.529412,1315.35294 L395.294118,1315.35294 C177.317647,1315.35294 0,1138.03529 0,920.058824 C0,702.082353 177.317647,524.764706 395.294118,524.764706 C416.188235,524.764706 436.517647,527.475294 456.847059,530.750588 C482.597647,274.487059 697.072941,73 960,73 Z M1016.47059,920.058824 L903.529412,920.058824 L903.529412,1202.41176 L1016.47059,1202.41176 L1016.47059,920.058824 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCloudDownloadSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCloudDownloadSolid, _Component);

  var _super = _createSuper(IconCloudDownloadSolid);

  function IconCloudDownloadSolid() {
    _classCallCheck(this, IconCloudDownloadSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCloudDownloadSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCloudDownload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCloudDownloadSolid.displayName = "IconCloudDownloadSolid";
  return IconCloudDownloadSolid;
}(Component);

IconCloudDownloadSolid.glyphName = 'cloud-download';
IconCloudDownloadSolid.variant = 'Solid';
IconCloudDownloadSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCloudDownloadSolid;
export { IconCloudDownloadSolid };